import { render, staticRenderFns } from "./product-wishlist-heart.vue?vue&type=template&id=132b9868&scoped=true"
import script from "./product-wishlist-heart.vue?vue&type=script&lang=js"
export * from "./product-wishlist-heart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b9868",
  null
  
)

export default component.exports